const VALID_PREFIXES = ["071", "073", "077", "078", "086"];

export function validatePhone(value: string): string {
  const digits = value.replace(/[^0-9]/g, "");
  if (!digits) return "Please enter your phone number";
  if (digits.startsWith("0") && digits.length !== 10)
    return "Phone number must be 10 digits (e.g. 0771234567)";
  if (digits.startsWith("263") && digits.length !== 12)
    return "Phone number must be 12 digits with country code (e.g. 263771234567)";
  if (!digits.startsWith("0") && !digits.startsWith("263"))
    return "Phone number must start with 0 or 263";
  const local = digits.startsWith("263") ? "0" + digits.slice(3) : digits;
  if (!VALID_PREFIXES.some((p) => local.slice(0, 3) === p))
    return "Please enter a valid Zimbabwean mobile number";
  return "";
}
